import { StoreState } from "./index";
import filter from "lodash/filter";
import groupBy from "lodash/groupBy";
import map from "lodash/map";
import maxBy from "lodash/maxBy";
import sum from "lodash/sum";
import { AnimationUnit } from "./all";

export function getExitTimeout(state: StoreState): number {
  const exitTimers = filter(state.all, { position: "leave" });
  const byIndex = groupBy(exitTimers, "index");
  const times = map(byIndex, (indices: AnimationUnit[]) => {
    const index = maxBy(indices, "timeout");

    return index ? index.timeout : 0;
  });

  return sum(times);
}

export function getEnterTimeout(state: StoreState): number {
  const exitTimers = filter(state.all, { position: "enter" });
  const byIndex = groupBy(exitTimers, "index");
  const times = map(byIndex, (indices: AnimationUnit[]) => {
    const index = maxBy(indices, "timeout");

    return index ? index.timeout : 0;
  });

  return sum(times);
}

export function getEnterOffset(state: StoreState, index: number): number {
  const exitTimers = filter(
    state.all,
    (unit: AnimationUnit) => unit.position === "enter" && unit.index < index
  );

  const byIndex = groupBy(exitTimers, "index");
  const times = map(byIndex, (indices: AnimationUnit[]) => {
    const index = maxBy(indices, "timeout");

    return index ? index.timeout : 0;
  });

  return sum(times);
}

export function getExitOffset(state: StoreState, index: number): number {
  const exitTimers = filter(
    state.all,
    (unit: AnimationUnit) => unit.position === "leave" && unit.index > index
  );

  const byIndex = groupBy(exitTimers, "index");
  const times = map(byIndex, (indices: AnimationUnit[]) => {
    const index = maxBy(indices, "timeout");

    return index ? index.timeout : 0;
  });

  return sum(times);
}

export const getAnimationStartTime = (state: StoreState) => state.startTime;
export const getAnimationStatus = (state: StoreState) => state.status;
